import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import './styles/styles.scss';
import { ThemeContextProvider } from './contexts/themeContext';
import './i18n';
import App from './App/App';
import reportWebVitals from './reportWebVitals';
import UserContextProvider from './contexts/userContext';
import './pages/common/vhelper/scroll.css';
import { loadConfig } from './config';
import Errorpage from './pages/presentation/demo-pages/helper/Errorpage';

// Load config first, then render the app
loadConfig()
	.then(() => {
		ReactDOM.render(
			<Router>
				<React.StrictMode>
					<ThemeContextProvider>
						<UserContextProvider>
							<App />
						</UserContextProvider>
					</ThemeContextProvider>
				</React.StrictMode>
			</Router>,
			document.getElementById('root'),
		);

		reportWebVitals();
	})
	.catch((error) => {
		console.error('Failed to load config.json:', error);
		// Optionally show an error message or fallback UI here
		ReactDOM.render(<Errorpage />, document.getElementById('root'));
	});

// ReactDOM.render(
// 	<Router>
// 		<React.StrictMode>
// 			<ThemeContextProvider>
// 				<UserContextProvider>
// 					<App />
// 				</UserContextProvider>
// 			</ThemeContextProvider>
// 		</React.StrictMode>
// 	</Router>,
// 	document.getElementById('root'),
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
